<script>
  import { Router, link, Route } from "svelte-routing";
  import { block } from "./toolbox.js";

  import Layout from "./Layout.svelte";
  import Test from "./Test.svelte";

  export let siteEndpoint;
  export let testEndpoint;
  export let url = "";
  let queryParams = new URLSearchParams(window.location.search);
  export let debug = queryParams.has('debug');
  let sitePromise = fetchSite(localStorage.getItem('lang') || 'lt');

  async function fetchSite(lang = 'lt') {
      const response = await fetch(siteEndpoint + '?lang=' + lang);
      sitePromise = await response.json();
  };

  function switchLang(lang) {
      localStorage.setItem('lang', lang);
      $: sitePromise = fetchSite(lang);
  }

  history.pushState = new Proxy(history.pushState, {
      apply (target, thisArg, argumentsList) {
          scrollTo(0,0);
          Reflect.apply(target, thisArg, argumentsList)
      }
  })
</script>

<main>
  {#await sitePromise}
  <p>loading...</p>

  {:then site}
  <Router url="{url}">
    {#each site['pages'] as page}
    <Route path="{page.slug == 'home' ? '' : page.slug}">
      <Layout on:langChangeNotify="{(ev) => switchLang(ev.detail)}" blocks={page['blocks']} debug={debug}/>
    </Route>
    {/each}

    <Route path="test">
      <Test endpoint={testEndpoint} />
    </Route>

  </Router>
  
  {:catch error}
  <p>Something went wrong: {error.message}</p>
  
  {/await}
</main>
